<a [routerLink]="setUrl()" class="neighborhood-card">
  <div class="screen">
    <div class="image-wrapper" [ngStyle]="{ backgroundImage: 'url(' + neighborhood.cover_picture_url + ')' }">
    </div>
  </div>
  <h4>{{ neighborhood.name }}</h4>
  <p>{{ updatedDescription | truncateText:"120" }}</p>
</a>
